import { assertInInjectionContext, DestroyRef, inject, INJECTOR } from '@angular/core';
import { SseDataAccess } from '../../data-access/sse.data-access';
import { SseResource, SseResourceInitOptions } from '../sse-resource';

/**
 * Helper function for creating an instance of `SseResource`
 * Returns the configured instance. Disconnects automatically when the injector gets destroyed
 */
export function sseResource<EventDefObject extends Record<string, unknown>>(
  init: SseResourceInitOptions<EventDefObject>
): SseResource<EventDefObject> {
  assertInInjectionContext(sseResource);
  const sseDataAccess = inject(SseDataAccess);
  const destroyRef = inject(DestroyRef);
  const resource = new SseResource<EventDefObject>(init, sseDataAccess, inject(INJECTOR));
  destroyRef.onDestroy(() => resource.disconnect());
  return resource;
}
